// Видео в телефонах ib-animated играют, только пока видны; при reduced-motion — только постеры.
if (!customElements.get('ib-animated-videos')) {
  customElements.define('ib-animated-videos', class extends HTMLElement {
    connectedCallback() {
      this.visibleVideos = new Set();
      this.videos = Array.from(this.querySelectorAll('video[data-src]'));
      if (!this.videos.length) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => this.update();
      this.motion.addEventListener('change', this.onMotionChange);
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) this.visibleVideos.add(entry.target);
          else this.visibleVideos.delete(entry.target);
        });
        this.update();
      }, { rootMargin: '0px', threshold: 0.5 });
      this.videos.forEach(video => this.observer.observe(video));
      // Значок «play» виден, пока ролик стоит; когда ролик играет — скрыт, чтобы не казалось, что он на паузе.
      this.videos.forEach(video => {
        if (video.ibBound) return; // при повторном подключении элемента обработчики уже стоят
        video.ibBound = true;
        const phone = video.closest('.iba-phone');
        video.addEventListener('playing', () => phone?.classList.add('is-playing'));
        video.addEventListener('pause', () => phone?.classList.remove('is-playing'));
      });
    }

    disconnectedCallback() {
      this.visibleVideos?.clear();
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.videos?.forEach(video => video.pause());
    }

    // Владелец 31.10: берём наименьший mp4, которого хватает на телефон этого экрана (высота × плотность экрана), не больше 720p.
    // Мобильный и обычный монитор получают 480p, Retina-монитор — 720p.
    pick(video, sources) {
      const mp4 = sources.filter(s => s.format === 'mp4').sort((a, b) => a.height - b.height);
      const need = video.getBoundingClientRect().height * (window.devicePixelRatio || 1) * 0.9;
      return (mp4.find(s => s.height >= need && s.height <= 720) || mp4.filter(s => s.height <= 720).pop() || mp4[0]).url;
    }

    // Лёгкие mp4 (480p, 720p) есть только в /products/<handle>.js; при ошибке — 1080p из data-src.
    source(video) {
      if (!video.ibSource) {
        video.ibSource = fetch(`${window.Shopify?.routes?.root || '/'}products/${video.dataset.product}.js`)
          .then(r => r.json())
          .then(p => {
            const media = p.media.find(m => m.media_type === 'video' && String(m.id) === video.dataset.media)
              || p.media.find(m => m.media_type === 'video' && m.aspect_ratio < 1);
            return this.pick(video, media.sources);
          })
          .catch(() => video.dataset.src);
      }
      return video.ibSource;
    }

    update() {
      const play = this.isConnected && !this.motion.matches;
      this.videos.forEach(video => {
        if (!play || !video.isConnected || !this.visibleVideos.has(video)) { video.pause(); return; }
        this.source(video).then(url => {
          if (!this.isConnected || !video.isConnected || !this.visibleVideos.has(video) || this.motion.matches) return;
          if (!video.getAttribute('src')) video.src = url || video.dataset.src;
          video.play().catch(() => {});
        });
      });
    }
  });
}
